import classNames from 'classnames/bind';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import { useSearchParamsContext } from 'contexts/searchParams';
import { useContext } from 'react';
import { ICountry } from '../types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  country: ICountry;
  forDeparture: boolean;
  markMatchedSubstrings(target: string): { __html: string };
}

const Country = ({ country, forDeparture, markMatchedSubstrings }: IProps) => {
  const { countryCode, countryName, countryNameEn, type } = country;
  const setModal = useContext(ModalFuncContext);
  const { setEverywhereSearch } = useSearchParamsContext();

  const onClickCountry = (code: string, name: string) => () => {
    setEverywhereSearch({ code, name, isDomestic: false });
    setModal({ type: Modal.NULL, position: ModalPosition.MAIN });
  };
  return (
    <li
      className={cx('list_item')}
      data-event-nlog="click"
      data-event-area-code={`${forDeparture ? 'dep' : 'arr'}.autocountry`}
      onClick={onClickCountry(countryCode, countryName)}
    >
      <a className={cx('anchor')}>
        <i className={cx('icon')} data-type={type.toUpperCase()} />
        <b className={cx('name')}>
          <span
            className={cx('name_inner')}
            dangerouslySetInnerHTML={markMatchedSubstrings(countryName)}
          />
          &nbsp;
          <span
            className={cx('en')}
            dangerouslySetInnerHTML={markMatchedSubstrings(countryNameEn)}
          />
        </b>
        <div className={cx('desc')}>모든 도시 및 공항</div>
      </a>
    </li>
  );
};

export default Country;
